import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';

type CommentCellProps = {
  comment: string | undefined;
  isReadOnly?: boolean;
  tooltip: string;
  onOpen: (event: React.MouseEvent<HTMLElement>) => void;
};

export const CommentCell = ({
  comment,
  isReadOnly = false,
  tooltip,
  onOpen,
}: CommentCellProps) => {
  const hasComment = Boolean(comment);
  const isClickable = !isReadOnly || hasComment;

  return (
    <Tooltip title={tooltip} placement="right">
      <span>
        <IconButton
          onClick={(e) => {
            if (isClickable) {
              onOpen(e);
            }
          }}
          disabled={!isClickable}
          sx={{
            color: hasComment ? 'primary.main' : 'text.disabled',
          }}
          size="small"
        >
          {hasComment ? <InsertCommentIcon /> : <ModeCommentOutlinedIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
};
